const CustomPropertiesEnum = {
  assetRequiredProperty: 'Asset Subscription License',
  userRequiredProperty: 'Subscription License',
  assetQuotaValue: ['Proficiency', 'FM'],
  assetNonQuotaValue: ['Awareness'],
  userQuotaValue: ['Proficiency', 'FM'],
  userNonQuotaValue: ['Awareness']
};

export { CustomPropertiesEnum };
export default CustomPropertiesEnum;
